import { getOr } from '@/utils/options';
import InfoIcon from 'components/src/svg/InfoIcon';
import { Paragraph } from 'components/src/typography';
import Image from 'next/image';
import * as React from 'react';
import { PackageCardFieldsFragment } from 'types/generated';
import CardModal from './CardModal';

type Props = {
  title?: string | null;
  modal: PackageCardFieldsFragment['iconContainerModal'];
  icons: PackageCardFieldsFragment['iconsCollection'];
};

const Icons = ({ title, modal, icons }: Props) => {
  const [modalOpen, setModalOpen] = React.useState(false);

  if (!icons?.items || icons.items.length === 0) {
    return null;
  }

  return (
    <div className="grid rounded-28 bg-white-15 px-16 py-8">
      <div className="flex justify-between">
        {title && <Paragraph classes="mb-16 !text-sm-fixed !font-bold text-black-100">{title}</Paragraph>}
        {modal && (
          <button
            className="flex h-24 w-24 items-center justify-center hover:cursor-pointer"
            onClick={() => setModalOpen(true)}
          >
            <InfoIcon />
          </button>
        )}
      </div>
      <div className="flex flex-wrap gap-x-4 gap-y-8">
        {icons.items.map(
          (icon, index) =>
            icon?.url && (
              <div key={index} className="relative">
                <Image
                  key={index}
                  src={icon?.url}
                  alt={getOr(icon.title, '')}
                  width={0}
                  height={0}
                  sizes={'100vw'}
                  className={'h-auto w-full'}
                />
              </div>
            )
        )}
      </div>
      <CardModal isOpen={modalOpen} modalData={modal} setModalOpen={setModalOpen} />
    </div>
  );
};
export default Icons;
